export const BRAILLER_LOAN_STATUS_OPTIONS = [
    {value: "ReadyForCheckout", text: "Ready For Checkout"},
    {value: "WaitList", text: "Wait List"},
    {value: "CheckedOut", text: "Checked Out"},
    {value: "Returned", text: "Returned"},
    {value: "RepairRequested", text: "Repair Requested"},
    {value: "Repair", text: "Repair"},
];

// Repair Statuses (for unloaned repairs)
export const BRAILLER_REPAIR_STATUS_OPTIONS = [
    {value: "Repair - Reported", text: "Repair - Reported"},
    {value: "Repair - InProgress", text: "Repair - In Progress"},
];

// Combined status options for the search dropdown
export const BRAILLER_HISTORY_STATUS_OPTIONS = [
    {value: "", text: "All"},
    // Loan Statuses
    {value: "ReadyForCheckout", text: "Ready For Checkout"},
    {value: "WaitList", text: "Wait List"},
    {value: "CheckedOut", text: "Checked Out"},
    {value: "Returned", text: "Returned"},
    {value: "RepairRequested", text: "Repair Requested"},
    {value: "Repair", text: "Repair"},
    // Repair Statuses (for unloaned repairs)
    {value: "Repair - Reported", text: "Repair - Reported"},
    {value: "Repair - InProgress", text: "Repair - In Progress"},
];